import type { ICollaborators } from '@/services/workbench';
import type { FC } from 'react';

export const Collaborator: FC<{ collaborators: ICollaborators[] }> = (
  props,
) => {
  // props
  const { collaborators } = props;

  return (
    <section className="flex items-center h-full -space-x-2">
      {collaborators.slice(0, 6).map((collaborator) => {
        const { uid, avatar } = collaborator;

        return (
          <div
            className="w-6 h-6 bg-center bg-cover ring-1 ring-white rounded-xl"
            style={{
              backgroundImage: `url("${avatar}")`,
            }}
            key={uid}
          />
        );
      })}
      {collaborators.length > 6 && (
        <div className="flex justify-center items-center w-6 h-6 ring-1 ring-white rounded-xl bg-primary text-xs text-white">
          +{collaborators.length - 6}
        </div>
      )}
    </section>
  );
};
